export const eur = (n) =>
  Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

export const packTotal = (pack) =>
  pack ? Number(pack.price) + (pack.free_shipping ? 0 : Number(pack.shipping || 0)) : 0;
